const ASCII_RULE = 'custom_ascii_characters';

const normalizeRuleSegments = (ruleString = '') =>
	ruleString
		.split('|')
		.map(segment => segment.trim())
		.filter(Boolean);

const withAsciiRuleString = (rules = '') => {
	const segments = normalizeRuleSegments(rules);

	if (!segments.includes(ASCII_RULE)) {
		segments.push(ASCII_RULE);
	}

	return segments.join('|') || ASCII_RULE;
};

const withAsciiRuleObject = (rules = {}) => ({
	...rules,
	[ASCII_RULE]: Object.hasOwn(rules, ASCII_RULE)
		? rules[ASCII_RULE]
		: true,
});

export const withAsciiRule = rules => {
	if (rules == null) {
		return ASCII_RULE;
	}

	if (typeof rules === 'string') {
		return withAsciiRuleString(rules);
	}

	if (Array.isArray(rules)) {
		return withAsciiRuleString(rules.join('|'));
	}

	return withAsciiRuleObject(rules);
};

export default withAsciiRule;
